import { createReducer } from '@cld/redux-helpers';
import {
  UPDATE_OPTIONS,
  CLEAR_OPTIONS,
  SELECT_DEFAULT_TRANSFORMATIONS,
} from '../constants/actionTypes';
import { PREDEFINED_TRANSFORMATIONS } from '../constants/general';
import { OptionsState, FilterType } from '../types';

export const initialState: OptionsState = {
  inlineContainer: '',
  inlineMode: true,
  insertCaption: 'Insert',
  removeHeader: false,
  filterSelection: FilterType.Folder,
  maxFiles: '1',
  folderName: '',
  isSearchFilterByAsset: false,
  filterByAsset: undefined,
  isSearchFilterByCustomExpression: false,
  filterByExpression: '',
  defaultTransformations: [[]],
  transformations: PREDEFINED_TRANSFORMATIONS,
  areCustomTransformationsEnabled: false,
  customTransformations: '',
};

export default createReducer(
  {
    [UPDATE_OPTIONS]: (
      state: OptionsState,
      resp: {
        payload?: OptionsState;
      }
    ) => ({
      ...state,
      ...resp.payload,
    }),
    [SELECT_DEFAULT_TRANSFORMATIONS]: (
      state: OptionsState,
      resp: {
        payload: { key: string; value: boolean };
      }
    ) => {
      const transformations = state.transformations?.map((item) => {
        return {
          ...item,
          isSelected: resp.payload.key === item.key ? resp.payload.value : item.isSelected,
        };
      });
      return {
        ...state,
        transformations,
      };
    },
    [CLEAR_OPTIONS]: () => initialState,
  },
  initialState
);
